import React, { useCallback, useEffect, useState } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { createCentrifugeAdapter } from 'api/centrifugeAdapter';
import PropTypes from 'prop-types';

import { receiveNewMessage as applicantReceiveNewMessage } from 'actions/applicantMessenger';
import { updateLeftNavigation } from 'actions/session';

import { getEnableWebsockets, getWssConfig } from 'selectors/session';

import { selectCurrentChannelId } from 'features/messengerv2/selectors';
import {
  addNewMessage,
  deleteChannel,
  setCurrentChatView,
  setUnreadMessages,
  updateChannel,
  updateChannelWithIndex,
  updateMessage,
} from 'features/messengerv2/slice';

import { PRODUCT_AREAS } from 'util/tracking_constants';
import { withUxRoot } from 'util/uxEvents';

import { VIEWS } from '../constants';
import MessengerView from '../MessengerView';

const MessengerRoot = ({
  wssConfig,
  onChangeView,
  onAddNewMessage,
  onUpdateMessage,
  onUpdateChannel,
  onDeleteChannel,
  currentChannelId,
  enableWebsockets,
  onSetUnreadMessages,
  onUpdateLeftNavigation,
  onUpdateChannelWithIndex,
  onApplicantReceiveNewMessage,
}) => {
  const [websocketsEnabled, setWebsocketsEnabled] = useState(false);

  const handleDeleteChannel = useCallback(
    data => {
      /** If user is in the channel that got deleted,
       * exit channel before removal */
      if (data.id === currentChannelId) {
        onChangeView({ view: VIEWS.INDEX, channelId: null });
      }

      onDeleteChannel(data.id);
    },
    [currentChannelId, onChangeView, onDeleteChannel]
  );

  useEffect(() => {
    if (enableWebsockets && !websocketsEnabled) {
      createCentrifugeAdapter({
        wssConfig,
        onAddNewMessage,
        onUpdateMessage,
        onUpdateChannel,
        onSetUnreadMessages,
        onUpdateLeftNavigation,
        onUpdateChannelWithIndex,
        onApplicantReceiveNewMessage,
        onDeleteChannel: handleDeleteChannel,
      });
      setWebsocketsEnabled(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enableWebsockets]);

  return <MessengerView />;
};

MessengerRoot.propTypes = {
  wssConfig: ImmutablePropTypes.map,
  currentChannelId: PropTypes.string,
  enableWebsockets: PropTypes.bool,
  onAddNewMessage: PropTypes.func.isRequired,
  onUpdateMessage: PropTypes.func.isRequired,
  onDeleteChannel: PropTypes.func.isRequired,
  onUpdateChannel: PropTypes.func.isRequired,
  onChangeView: PropTypes.func.isRequired,
  onSetUnreadMessages: PropTypes.func.isRequired,
  onUpdateLeftNavigation: PropTypes.func.isRequired,
  onUpdateChannelWithIndex: PropTypes.func.isRequired,
  onApplicantReceiveNewMessage: PropTypes.func.isRequired,
};

export default connect(
  state => ({
    wssConfig: getWssConfig(state),
    currentChannelId: selectCurrentChannelId(state),
    enableWebsockets: getEnableWebsockets(state),
  }),
  {
    onAddNewMessage: addNewMessage,
    onUpdateMessage: updateMessage,
    onDeleteChannel: deleteChannel,
    onUpdateChannel: updateChannel,
    onChangeView: setCurrentChatView,
    onSetUnreadMessages: setUnreadMessages,
    onUpdateLeftNavigation: updateLeftNavigation,
    onUpdateChannelWithIndex: updateChannelWithIndex,
    onApplicantReceiveNewMessage: applicantReceiveNewMessage,
  }
)(withUxRoot({ productArea: PRODUCT_AREAS.MESSAGING })(MessengerRoot));
